import { Button, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { useCallback } from 'react';
import { HiChevronLeft } from 'react-icons/hi';

import { RequestFilters } from '../../hooks/useRequestFilters';

// The value has to be a string to satisfy the RadioGroup component,
// which requires a string value
const options = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
  { label: 'All', value: 'null' },
];

type Props = {
  filters: RequestFilters;
  handleRadioFilterChange: (key: string) => (nextValue: string) => void;
  resetView: () => void;
};

export const KnownShipperFilter = ({ filters, handleRadioFilterChange, resetView }: Props) => {
  const localOnChange = useCallback(
    (nextValue: string) => {
      handleRadioFilterChange('is_known_shipper')(nextValue);
    },
    [handleRadioFilterChange],
  );

  return (
    <Stack spacing="2" pt="2">
      <Stack direction="row" align="center" spacing="2">
        <Button variant="ghost" textStyle="label" size="xs" leftIcon={<HiChevronLeft />} onClick={resetView}>
          Known Shipper
        </Button>
      </Stack>

      <Stack>
        <RadioGroup value={filters.is_known_shipper as string} onChange={localOnChange}>
          {options?.map((node) => (
            <Stack key={node.label} py="2">
              <Radio value={node.value}>{node.label}</Radio>
            </Stack>
          ))}
        </RadioGroup>
      </Stack>
    </Stack>
  );
};
